<div *ngIf="month" class="grid no-padding">
  <div class="row" *ngFor="let week of month.weeks; trackBy: trackByItems">
    <div class="col no-padding" size="12">
      <app-season-calendar-week
        [week]="week"
        [selectedSlots]="selectedSlots"
        [defaultColours]="defaultColours"></app-season-calendar-week>
    </div>
  </div>
</div>
